export default "__VITE_ASSET__DFbFihxo__"